export const DEFAULT_SPINNER = 'circle'

export const SPINNER_OPTIONS = Object.freeze([
  { value: 'circle', label: 'Cercle classique' },
  { value: 'circle-8', label: 'Billes colorées' },
  { value: 'circle-10', label: 'Anneaux' },
  { value: 'cube-grid', label: 'Grille de cubes' },
  { value: 'jumper', label: 'Ondes' },
  { value: 'letter-cube', label: 'Cube ESKWEB' },
  { value: 'mike-pad', label: 'Bloc-notes' },
  { value: 'plane', label: 'Barres animées' },
  { value: 'stretch', label: 'Étirement' },
  { value: 'three-dots', label: 'Points en mouvement' },
  { value: 'dragster-neon', label: 'Dragster Neon X' },
  { value: 'dragster', label: 'Dragster' }
])

const SPINNER_KEYS = SPINNER_OPTIONS.map(option => option.value)

export function normalizeSpinner(spinner) {
  return SPINNER_KEYS.includes(spinner) ? spinner : DEFAULT_SPINNER
}

export function getSpinnerLabel(spinner) {
  const normalizedSpinner = normalizeSpinner(spinner)
  const option = SPINNER_OPTIONS.find(item => item.value === normalizedSpinner)

  return option ? option.label : SPINNER_OPTIONS[0].label
}
